/**
 *  Event Service
 * 
 * @copyright NIIT Technologies Ltd. 2017-18
 */

import { Component, Injectable, Inject, ReflectiveInjector } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';

import { BaseService } from './base.service';
import { Event, NotificationType } from '../common/base.data';

/**
 * Event Service
 */
@Injectable()
export class EventService extends BaseService {
    private eventSubject: Subject<Event> = null;
    private observer: Observable<Event> = null;

    /**
     * Initialize
     */
    constructor() {
        super();
        //
        this.eventSubject = new Subject<Event>();
        this.observer = this.eventSubject.asObservable();
    }

    /**
     * Gets Event Observer
     */
    public getEventObserver(): Observable<Event> {
        return this.observer;
    }

    /**
     * Raise Event
     * 
     * @param event Event
     */
    public raiseEvent(event: Event): void {
        this.eventSubject.next(event);
    }
}